// extracted by mini-css-extract-plugin
export default {"overlayHeaderTitle":"CustomPropertyStringEditor-module__overlayHeaderTitle--vwjAT","anchorButton":"CustomPropertyStringEditor-module__anchorButton--_prb_"};